import request from '../plugins/axios'

const endpoint = action => `/crmLead/${action}`

export const getLeadList = params => request({ url: endpoint('index'), method: 'get', params })
export const getLeadDetail = leadId => request({ url: endpoint('show'), method: 'get', params: { leadId } })
export const revealLeadIdentity = data => request({ url: endpoint('reveal'), method: 'post', data })
export const getLeadOptions = () => request({ url: endpoint('options'), method: 'get' })
export const createLead = data => request({ url: endpoint('store'), method: 'post', data })
export const updateLead = data => request({ url: endpoint('update'), method: 'put', data })
export const deleteLead = data => request({ url: endpoint('destroy'), method: 'delete', data })
export const getLeadActivities = params => request({ url: endpoint('activityIndex'), method: 'get', params })
export const createLeadActivity = data => request({ url: endpoint('activityStore'), method: 'post', data })
export const createLeadContactWay = data => request({ url: endpoint('contactWay'), method: 'post', data })
export const retryLeadWeComSync = data => request({ url: endpoint('retrySync'), method: 'post', data })
export const prepareLeadAddFriend = data => request({ url: endpoint('addFriend'), method: 'post', data })
